module.exports = __webpack_public_path__ + "static/media/6fbe5b35.jpg";